<script setup lang="ts">
import type { Gift } from '@consumer/types/serializers'
import GiftlyPrepaidGiftInfo from '@consumer/modules/v2/layout/Footer/GiftlyPrepaidGiftInfo.vue'
import TrustPilot from '@consumer/modules/v2/layout/Footer/TrustPilot.vue'

withDefaults(defineProps<{
  gift?: Gift
}>(), {  })
</script>

<template>
  <div id="footer" class="paragraphs relative flex flex-col flex-grow">
    <TrustPilot :gift="gift"/>
    <GiftlyPrepaidGiftInfo/>
  </div>
</template>

<style>
/* stylelint-disable selector-class-pattern */
.klaviyo-form-VUVtG3 {
  form {
    border: 0 !important;
  }

  div,
  span,
  p {
    font-family: Gilroy, sans-serif !important;
  }
}
/* stylelint-enable selector-class-pattern */
</style>
